export function formatUserName(user) {
  if (!user) {
    return "—";
  }

  if (user.displayName) {
    return user.displayName;
  }

  const parts = [user.firstName, user.lastName].filter(Boolean);
  if (parts.length) {
    return parts.join(" ");
  }

  return user.email || "—";
}

export function formatDateTime(value) {
  if (!value) {
    return "Never";
  }

  try {
    return new Date(value).toLocaleString();
  } catch {
    return "—";
  }
}

export function formatShortDate(value) {
  if (!value) {
    return "Never";
  }

  try {
    return new Date(value).toLocaleDateString();
  } catch {
    return "—";
  }
}
